import React, { useContext, useState } from 'react';
import classNames from './exportModal.module.scss';
import { Select } from 'antd';
import { useMutation } from 'react-query';
import { getAxiosTokenInstance } from '../../../utils/axiosInstance';
import { FirebaseContext } from '../../../context/FirebaseContext';
import LoadingAnimation from '../../../components/LoadingAnimation';
import { useAllClasses } from '../../../NecttosComp/APICaller/queryHooks';
import { Formik } from 'formik';
import { Body, Header, Main } from '../../../NecttosComp/Layout/Layout';
import Button from '../../../NecttosComp/Button/Button';
import { OLoading } from '../../../static/svg/icons';
import Input2 from '../../../NecttosComp/Input/Input2';
import Instruction from '../../../Documentation/Instruction';

const exportPdf = async ({ olddata, setLoading }) => {
	try {
		const instance = await getAxiosTokenInstance();
		const { collegeId, classId } = olddata;

		const resp = await instance.post(
			'/college/reportGeneration/menteeProfilePDF',
			{ collegeId, classId },
			{
				responseType: 'blob',
			},
		);

		if (resp.data.statusCode === 400) {
			setLoading(false);
			throw new Error(resp.data.message || 'API Error');
		}

		return resp.data;
	} catch (error) {
		setLoading(false);
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};
const { Option } = Select;

const MenteePDF = ({ onClose }) => {
	const { collegeId } = useContext(FirebaseContext);
	const [custom, setCustom] = useState(false);
	const [stateData, setStateData] = useState({});
	const exportPdfMutation = useMutation(exportPdf);
	const [loading, setLoading] = useState(false);






	const allClasses = useAllClasses({ needAll: false, classOnly: true });

	const onExportExam = async () => {
		try {
			setLoading(true);
			const { classId, className } = stateData;
			const link = document.createElement('a');
			link.target = '_blank';
			link.download = `Electoral Roll ${className}`;

			const pdfData = await exportPdfMutation.mutateAsync({ olddata: { collegeId, classId }, setLoading });
			link.href = URL.createObjectURL(new Blob([pdfData], { type: 'application/pdf' }));
			link.click();

			setLoading(false);
			onClose();
		} catch (e) {}
	};

	console.log({stateData:allClasses?.data});
	
	return (
		<>
			<Main title='Mentee Profile PDF' width='500px' height='500px'>
				<Header>
					<div className='flex justify-end w-full'>
						<Instruction keyId={'menteeForm'}/>
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					</div>
				</Header>
				<Body>
					<div className='h-[40%]'>
						{loading ? (
							<OLoading />
						) : (
							<div className=' '>
								<div className=''>
									<CustomOrStandard setCustom={setCustom} custom={custom} />
									{custom ? <CustomInput stateData={stateData} setStateData={setStateData} /> : <StandardInput allClasses={allClasses}  stateData={stateData} setStateData={setStateData} />}
								</div>
							</div>
						)}
					</div>
					<div className='flex justify-center '>
						<Button type='pdf' onClick={onExportExam}>
							Mentee Profile PDF
						</Button>
					</div>
				</Body>
			</Main>
		</>
	);
};

const CustomOrStandard = ({ setCustom, custom }) => (
	<div className='m-4 pl-40'>
		<input type='checkbox' style={{ height: 20, width: 20, marginRight: 10 }} defaultChecked={custom} onChange={() => setCustom(!custom)} />
		Custom
	</div>
);

const CustomInput = ({ stateData, setStateData }) => <Input2 type='text' fieldName='START' returnKey='year' state={stateData} setState={setStateData} className='w-[470px]' />;





const StandardInput = ({ allClasses, stateData, setStateData }) => (
	<div>
		<div>
			<Input2 type='drop' fieldName='Select Class' returnKey='classId' didntShowKey state={stateData} setState={setStateData} options={allClasses?.data || []} optionKey='_id' optionDisplay='className'  className='w-[470px]' />
		</div>
	</div>
);

export default MenteePDF;


